import React, { useEffect, useState } from "react";

import { Doughnut, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  ArcElement
} from "chart.js";
import Content from "../../../components/Contents/Content";
import { getChatLineData, BasketStockListdata } from "../../../Services/UserService/User";
import { Link, useLocation } from "react-router-dom";
import { fDateTime } from "../../../../Utils/Date_formate";
import ReusableModal from '../../../components/Models/ReusableModal';
import { BasketSubscriptionCount } from "../../../Services/UserService/clientService";


ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
);



const BasketDetail = () => {


  const [activeTab, setActiveTab] = useState("rational");
  const [itemdata, setItemdata] = useState();
  const [model, setModel] = useState(false);
  const location = useLocation();
  const { item } = location?.state;



  const [selectedRange, setSelectedRange] = useState("5D");
  const [newChartData, setNewChartData] = useState();
  const [limitData, setLimitData] = useState(5);
  const token = localStorage.getItem("token");





  const stripHtmlTags = (input) => {
    if (!input) return "";
    return input.replace(/<\/?[^>]+(>|$)/g, "");
  };



  function calculateTypeWeightages(stockDetails) {
    const typeWeightages = {};

    stockDetails.forEach((item) => {
      const { type, weightage } = item;
      typeWeightages[type] = (typeWeightages[type] || 0) + weightage;
    });

    const labels = [];
    const values = [];
    const backgroundColor = [];
    const hoverBackgroundColor = [];


    const colorMap = {
      "Small Cap": { base: "#FF5252", hover: "#FF867F" },
      "Mid Cap": { base: "#FF9800", hover: "#FFB74D" },
      "Large Cap": { base: "#4CAF50", hover: "#66BB6A" },
    };

    for (const type in typeWeightages) {
      labels.push(`${type} (${typeWeightages[type]}%)`);
      values.push(typeWeightages[type]);


      const color = colorMap[type] || { base: "#9E9E9E", hover: "#BDBDBD" };
      backgroundColor.push(color.base);
      hoverBackgroundColor.push(color.hover);
    }

    return { labels, values, backgroundColor, hoverBackgroundColor };
  }



  const handleRangeChange = (range, days) => {
    setSelectedRange(range);
    setLimitData(days);
  };

  const colorList = ["#28a745", "#007bff", "#ffc107", "#dc3545"];


  const createChartData = () => {
    if (!newChartData || newChartData.length === 0) return { labels: [], datasets: [] };


    const sortedData = [...newChartData].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

    const dates = [...new Set(sortedData.map(item => item.created_at))].sort();
    const labels = dates.map(date =>
      new Date(date).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
      })
    );


    const basketData = dates.map(date => {
      const dayData = sortedData.filter(item => item.created_at === date);
      if (dayData.length === 0) return 100;
      const avgProfitLoss = dayData.reduce((sum, item) => sum + (item.apiprofitloss || 0), 0) / dayData.length;
      return (100 + avgProfitLoss).toFixed(2);
    });


    const stockData = dates.map(date => {
      const dayData = sortedData.filter(item => item.created_at === date);
      if (dayData.length === 0) return 100;
      const avgProfitLossPercentage = dayData.reduce((sum, item) => sum + (item.profitlosspercentage || 0), 0) / dayData.length;
      return (100 + avgProfitLossPercentage).toFixed(2);
    });


    const stockName = sortedData.length > 0 ? sortedData[0].stockname : "--";

    return {
      labels,
      datasets: [
        {
          label: item?.title || "Basket",
          data: basketData,
          borderColor: "#28a745",
          backgroundColor: "#28a745",
          fill: false,
          tension: 0.4,
          pointRadius: 0,
          pointHoverRadius: 6,
          borderWidth: 2,
        },
        {
          label: stockName,
          data: stockData,
          borderColor: "#007bff",
          backgroundColor: "#007bff",
          fill: false,
          tension: 0.4,
          pointRadius: 0,
          pointHoverRadius: 6,
          borderWidth: 2,
        }
      ],
    };
  };



  const chartDataLine = createChartData();

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        titleColor: '#ffffffff',
        bodyColor: '#000000ff',
        borderColor: '#000000ff',
        borderWidth: 1,
        cornerRadius: 8,
        displayColors: false,
        position: 'nearest',
        callbacks: {
          title: function (context) {
            return '';
          },
          label: function (context) {
            const stockName = context.dataset.label;
            const value = context.formattedValue;
            return `${stockName}: ₹${value}`;
          },
          labelColor: function (context) {
            return {
              borderColor: context.dataset.borderColor,
              backgroundColor: context.dataset.borderColor,
              borderWidth: 2,
              borderRadius: 2,
            };
          }
        },
        titleFont: {
          size: 0
        },
        bodyFont: {
          size: 14,
          weight: 'normal'
        },
        padding: 10,
        caretSize: 6,
        caretPadding: 8,
        displayColors: false,
        filter: function (tooltipItem) {
          return true;
        },
        itemSort: function (a, b) {
          if (a.dataset.label === item?.title) {
            return -1;
          }
          return 1;
        }
      },
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: true,
          color: 'rgba(255, 255, 255, 0.1)',
        },
        ticks: {
          autoSkip: false,
          maxRotation: 45,
          minRotation: 30,
          maxTicksLimit: limitData,
          color: '#ffffffff',
          font: {
            size: 12,
          },
        },


      },
      y: {
        beginAtZero: false,
        grid: {
          display: true,
          color: 'rgba(255, 255, 255, 0.1)',
        },
        ticks: {
          color: '#ffffffff',
          font: {
            size: 12
          },
          callback: function (value) {
            return '₹' + value.toFixed(2);
          },
        },
      },
    },
    interaction: {
      mode: 'index',
      intersect: false,
    },
    hover: {
      mode: 'index',
      intersect: false,
    },
  };


  const getLatestValues = () => {
    if (!newChartData || newChartData.length === 0) {
      return {
        basketValue: '--',
        stockValue: '--',
        stockName: '--'
      };
    }


    const sortedData = [...newChartData].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));


    const latestEntry = sortedData[0];



    const basketValue = (100 + (latestEntry?.apiprofitloss || 0)).toFixed(2);


    const stockValue = (100 + (latestEntry.profitlosspercentage || 0)).toFixed(2);

    const stockName = latestEntry.stockname;

    return { basketValue, stockValue, stockName };
  };

  const { basketValue, stockValue, stockName } = getLatestValues();

  const typeData = calculateTypeWeightages(item.stock_details);

  const chartData = {
    labels: typeData.labels,
    datasets: [
      {
        data: typeData.values,
        backgroundColor: typeData.backgroundColor,
        hoverBackgroundColor: typeData.hoverBackgroundColor,
      },
    ],
  };

  const chartLineData = async () => {
    try {
      const data = {
        basket_id: item._id,
        limit: limitData,
      };
      const response = await getChatLineData(data, token);
      if (response.status) {
        setNewChartData(response.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    chartLineData();
  }, [limitData]);

  useEffect(() => {
    setItemdata(item);
  }, [item]);

  return (
    <Content
      Page_title="Basket Detail"
      button_status={false}
      backbutton_status={true}
      backbutton_title="Back"
    >
      <div className="pb-3">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-md-2">
                <img
                  src={item?.image}
                  alt="Basket"
                  className="img-fluid mb-3"
                />
              </div>
              <div className="col-md-10">
                <h5 className="mb-0 text-yellow" >
                  <b>{item?.title}</b>
                </h5>
                <p className="basket-description">
                  {stripHtmlTags(item?.description)}
                </p>
                {item?.description.length > 350 && (
                  <button
                    onClick={() => setModel(true)}
                    className="btn btn-sm btn-secondary"
                  >
                    Read More..
                  </button>
                )}
              </div>
              <div className="row">
                <div className="col-md-7">
                  <ul className="list-group list-group-flush list mt-4">
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      Launch Date{" "}
                      <span className="badge bg-dark text-white rounded-pill">
                        {fDateTime(item?.created_at)}
                      </span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      Theme{" "}
                      <span className="badge bg-success rounded-pill">
                        {item?.themename}
                      </span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center border-bottom">
                      Since Launch{" "}
                      <span className="badge bg-danger rounded-pill">
                        {item?.cagr_live} %
                      </span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      No. of stocks{" "}
                      <span className="badge bg-warning rounded-pill text-dark">
                        {item?.stock_details.length}
                      </span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      Validity{" "}
                      <span className="badge bg-primary rounded-pill">
                        {item?.validity}
                      </span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      Rebalance Frequency{" "}
                      <span className="badge bg-success rounded-pill">
                        {item?.frequency}
                      </span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      Next Rebalance Date{" "}
                      <span className="badge bg-primary rounded-pill">
                        {item?.next_rebalance_date}
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="col-md-5">
                  <Doughnut data={chartData} className="mx-auto" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="alert alert-warning" role="alert">
        Minimum Investment Amount: <strong>{item?.mininvamount}</strong>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="card shadow ch">
            <div className="card-body">
              <div className="chart-tab">
                <ul className="nav nav-pills justify-content-end py-1 px-4" role="tablist">
                  {[
                    { label: "5D", days: 5 },
                    { label: "1M", days: 30 },
                    { label: "6M", days: 183 },
                    { label: "MAX", days: 100000 },
                  ].map((range) => (
                    <li className="nav-item" key={range.label}>
                      <button
                        className={`nav-link ${selectedRange === range.label ? "active" : ""}`}
                        onClick={() => handleRangeChange(range.label, range.days)}
                      >
                        {range.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="tab-content basket-chart-data mx-auto custom-width" style={{ width: "100%" }}>
                <div className="container tab-pane active">
                  <h4 className="mt-3 text-yellow">Historical Performance</h4>
                  <hr />

                  <div className="d-flex flex-wrap mb-3 mt-3">
                    <h6 className="text-white mb-0">
                      Current value of <b>₹100</b> invested once <b>{selectedRange}</b> at launch would be
                    </h6>
                  </div>
                  <div className="d-flex justify-content-center align-items-center">
                    <div className="row mb-3 w-100 justify-content-center" style={{ maxWidth: "800px" }}>
                      {/* First Box */}
                      <div className="col-md-5 mb-2">
                        <div
                          className="card border"
                          style={{
                            backgroundColor: '#f8f9fa',
                            borderLeft: '4px solid #28a745'
                          }}
                        >
                          <div className="card-body py-2 px-3 ">
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <h6
                                  className="mb-0 fw-bold"
                                  style={{
                                    color: '#28a745',
                                    fontSize: '14px'
                                  }}
                                >
                                  {item?.title || 'Basket'}
                                </h6>
                              </div>
                              <div>
                                <span className="fw-bold" style={{ fontSize: '16px' }}>
                                  ₹ {basketValue}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Second Box */}
                      <div className="col-md-5 mb-2">
                        <div
                          className="card border"
                          style={{
                            backgroundColor: '#f8f9fa',
                            borderLeft: '4px solid #007bff'
                          }}
                        >
                          <div className="card-body py-2 px-3">
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <h6
                                  className="mb-0 fw-bold"
                                  style={{
                                    color: '#007bff',
                                    fontSize: '14px'
                                  }}
                                >
                                  {stockName}
                                </h6>
                              </div>
                              <div>
                                <span className="fw-bold" style={{ fontSize: '16px' }}>
                                  ₹ {stockValue}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ width: '100%', overflowX: 'auto' }}>
                    <div style={{ minWidth: `${chartDataLine.labels.length * 60}px` }}>
                      <Line data={chartDataLine} options={options} />
                    </div>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          </div>
        </div>
      </div>
      <div className="row pt-3 align-items-center">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-start mb-3">
                <h6 className="fw-bold text-primary mb-0">Description</h6>
              </div>
              <hr />
              <div className="row">
                <div className="col-md-12">
                  <div
                    className="text-justify"
                    style={{ lineHeight: "1.7", fontSize: "15px", color: "#ffffffff" }}
                    dangerouslySetInnerHTML={{ __html: item?.short_description }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row pt-3 align-items-center">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <ul className="nav nav-pills mb-3 justify-content-center">
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === "rational" ? "active btn-primary" : ""
                      }`}
                    onClick={() => setActiveTab("rational")}
                  >
                    Rational
                  </button>
                </li>
                <hr />
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === "methodology" ? "active btn-primary" : ""
                      }`}
                    onClick={() => setActiveTab("methodology")}
                  >
                    Methodology
                  </button>
                </li>
              </ul>

              <div>
                {activeTab === "rational" && (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="text-white" dangerouslySetInnerHTML={{ __html: item?.rationale }} />
                    </div>
                  </div>
                )}
                {activeTab === "methodology" && (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="text-white" dangerouslySetInnerHTML={{ __html: item?.methodology }} />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {item?.isSubscribed && !item.isActive ?
        <div className="card-footer mt-3 text-center">
          <Link
            to={`/user/rebalancestock/${item._id}`}
            state={{ data: item }}
            className="btn btn-primary w-50 mx-auto mt-3"
          >
            View Detail
          </Link>
        </div>
        :
        <div className="card-footer mt-3 text-center">
          <Link
            to="/user/basketstocklist"
            state={{ item }}
            className="btn btn-primary w-50 mx-auto mt-3"
          >
            View Detail
          </Link>
        </div>}

      <ReusableModal
        show={model}
        onClose={() => setModel(false)}
        title={<span><b>{item?.title}</b></span>}
        body={<p>{stripHtmlTags(item?.description)}</p>}
        footer={
          <button
            type="button"
            className="btn btn-light"
            onClick={() => setModel(false)}
          >
            Close
          </button>
        }
      />
    </Content>
  );
};

export default BasketDetail;